import { APIClient } from "./apiCore";
import utilsApi from "../utils/api";
import * as url from "./urls";

const api = new APIClient();

export interface ContactsPageResponse {
  contacts: any[];
  total: number;
  page: number;
  limit: number;
  hasMore: boolean;
}

const getContacts = (filters?: object) => {
  return api.get(url.GET_CONTACTS, filters);
};

// Uses the authenticated utils/api instance (cookie/localStorage token + auto-refresh)
// instead of APIClient (default axios, no auth headers set).
const getContactsPaginated = (
  page: number,
  limit = 50,
): Promise<ContactsPageResponse> => {
  return utilsApi
    .get(`${url.GET_CONTACTS}?page=${page}&limit=${limit}`)
    .then((r) => r.data as ContactsPageResponse);
};

const inviteContact = (data: object) => {
  return api.create(url.INVITE_CONTACT, data);
};
export { getContacts, getContactsPaginated, inviteContact };
